<template>
  <div class="getReportDetail-select">
    <client-module :moduletitle="title" :showTitle="showTitle" :hint="hint">
      <div class="time-title" v-if="timeTitle" :style="[titleStyle]">
        {{ timeTitle }}
      </div>
      <div class="time-switch">
        <skydropdown-select
          class="time-select"
          :options="groups"
          @change="change"
          :value="selecttimetype"
        >
        </skydropdown-select>
        <!-- 日期选择器 -->
        <el-date-picker
          class="time-picker"
          v-model="startDate"
          :type="pickerType"
          :firstDayOfWeek="1"
          :format="format"
          :clearable="false"
          @change="dataChange"
          placeholder="请选择日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <div class="time-date" v-if="startDate && showDateData">
          <span>{{ startDate }}</span>
          <span>至</span>
          <span>{{ endDate }}</span>
        </div>
      </div>
      <div
        v-if="btnName"
        class="event"
        slot="event"
        :style="eventStyle"
        @click="skip"
      >
        {{ btnName }}
      </div>
      <slot v-if="hint" name="hint" slot="hint"></slot>
    </client-module>
  </div>
</template>

<script>
import { googleTimeSwitch } from '@/common/dictionary'
import { getWeekTime, transferDate, GetMonthStr } from '@/utils/index.js'
import clientModule from '@/components/client/clientModule/clientModule'
import skydropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect'
import { getDateRegion } from '@/common/util.js'
export default {
  props: {
    title: {
      type: String,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    btnName: {
      type: String,
    },
    eventStyle: {
      type: Object,
    },
    hint: {
      type: Boolean,
      default: false,
    },
    timeType: {
      type: String,
      default: 'week',
    },
    groups: {
      type: Array,
      default() {
        return googleTimeSwitch
      },
    },
    lastDay: {
      type: Boolean,
      default: false,
    },
    lastMonth: {
      type: Boolean,
      default: false,
    },
    customDisabledDate: {
      type: Function,
    },
    initialValue: {
      type: Boolean,
      default: true,
    },
    showDateData: {
      type: Boolean,
      default: true,
    },
    timeTitle: {
      type: String,
      default: '',
    },
    titleStyle: {
      type: Object,
    },
  },
  name: 'dateSwitchSelector',
  data() {
    let that = this
    return {
      startDate: '',
      endDate: '',
      format: 'yyyy 第 WW 周',
      pickerType: 'week',
      selecttimetype: 'WEEKLY',
      // groups: googleTimeSwitch,
      pickerOptions: {
        disabledDate(time) {
          return that.dealDisabledDate(time)
        },
      },
    }
  },
  mounted() {},
  methods: {
    change(val) {
      this.selecttime = ''
      this.selecttimetype = val
      switch (val) {
        case 'WEEKLY':
          this.pickerType = 'week'
          this.format = 'yyyy 第 WW 周'
          this.dataPeriod = '前一周'

          if (this.WeeklyOlData) {
            this.dataChange(this.WeeklyOlData)
          } else {
            this.getWeek()
          }
          break
        case 'DAILY':
          this.pickerType = 'date'
          this.format = 'yyyy-MM-dd'
          this.dataPeriod = '前一天'

          if (this.DailyOlData) {
            this.dataChange(this.DailyOlData)
          } else {
            this.getDetailDay()
          }
          break
        case 'MONTHLY':
          this.pickerType = 'month'
          this.format = 'yyyy-MM'
          this.dataPeriod = '前一月'

          if (this.MonthlyOlData) {
            this.dataChange(this.MonthlyOlData)
          } else {
            this.getDetailMonth()
          }
          break
      }
    },
    // 时间选择
    dataChange(val) {
      if (!val) {
        this.getWeek()
        this.getReportData()
        return false
      }
      let { selecttimetype } = this
      // 周报
      if (selecttimetype === 'WEEKLY') {
        this.WeeklyOlData = val
        // 处理月份结束日期
        let weekEnd = val.getTime() + 6 * 24 * 3600 * 1000
        weekEnd = transferDate(new Date(weekEnd))
        let time = transferDate(val)

        this.startDate = time
        this.endDate = weekEnd
        this.describeDate('week', this.startDate, this.endDate)
      }
      // 日报
      if (selecttimetype === 'DAILY') {
        this.DailyOlData = val
        let time = transferDate(val)

        this.startDate = time
        this.endDate = time
        this.describeDate('day', this.startDate, this.endDate)
      }
      // 月报
      if (selecttimetype === 'MONTHLY') {
        this.MonthlyOlData = val
        let time = transferDate(val)
        // 求指定月长度
        let M = val.getMonth() + 1
        let Y = val.getFullYear()
        let lange = new Date(Y, M, 0).getDate()

        // 处理月份结束日期
        let arr = time.split('-')
        arr[2] = lange - 0

        this.startDate = time
        this.endDate = arr.join('-')
        this.describeDate('month', this.startDate, this.endDate)
      }
      this.getReportData()
    },
    // 时间选择器返回限制
    dealDisabledDate(time) {
      let { selecttimetype, lastDay, lastMonth, customDisabledDate } = this
      // 自定义日期范围
      if (customDisabledDate) {
        return customDisabledDate(time, selecttimetype)
      }

      if (selecttimetype === 'WEEKLY') {
        //按周日为一周的最后一天计算
        var week = new Date()
        //今天是这周的第几天
        var today = week.getDay() * 24 * 3600 * 1000

        // 三个月的开始结束时间
        let date = GetMonthStr(3)
        let end = new Date(date.last).getTime()
        return time.getTime() > Date.now() - today || time.getTime() < end
      }
      if (selecttimetype === 'DAILY') {
        // 三个月的开始结束时间
        let date = GetMonthStr(3, 'day')
        if (lastDay) {
          let day = getDateRegion('DAY').split('至')[1]
          date.now = day
        }
        let start = new Date(date.now).getTime()
        let end = new Date(date.last).getTime()
        return time.getTime() < end || time.getTime() > start
      }
      if (selecttimetype === 'MONTHLY') {
        // 三个月的开始结束时间
        let date = GetMonthStr(3)
        let end
        if (lastMonth) {
          let month = getDateRegion('MONTH').split('至')[1]
          end = new Date(month).getTime()
        } else {
          end = Date.now()
        }
        let start = new Date(date.last).getTime()
        return time.getTime() > end || time.getTime() < start
      }
    },
    // 获取时间初始值
    getWeek() {
      this.startDate = getWeekTime('start')
      this.endDate = getWeekTime('end')
      this.selecttimetype = 'WEEKLY'
      this.pickerType = 'week'
      this.format = 'yyyy 第 WW 周'
      this.describeDate('week', this.startDate, this.endDate)
      this.getReportData()
    },
    // 日报初始化
    getDetailDay() {
      this.startDate = getDateRegion('DAY').split('至')[0]
      this.endDate = getDateRegion('DAY').split('至')[1]
      this.selecttimetype = 'DAILY'
      this.pickerType = 'date'
      this.format = 'yyyy-MM-dd'
      this.describeDate('day', this.startDate, this.endDate)
      this.getReportData()
    },
    // 月报初始化
    getDetailMonth() {
      let { lastMonth } = this
      if (lastMonth) {
        this.startDate = getDateRegion('MONTH').split('至')[0]
        this.endDate = getDateRegion('MONTH').split('至')[1]
      } else {
        this.startDate = getDateRegion('NEWMONTH').split('至')[0]
        this.endDate = getDateRegion('NEWMONTH').split('至')[1]
      }
      this.selecttimetype = 'MONTHLY'
      this.pickerType = 'month'
      this.format = 'yyyy-MM'
      this.describeDate('month', this.startDate, this.endDate)
      this.getReportData()
    },
    // 请求数据
    getReportData() {
      let { selecttimetype, startDate, endDate } = this
      this.$emit('change', { selecttimetype, startDate, endDate })
      this.$emit('reportData', { selecttimetype, startDate, endDate })
    },
    // 查看更多
    skip() {
      this.$emit('skip')
    },
    // 时间描述文本处理
    describeDate(type, start, end) {
      this.$emit('describeDate', { type, start, end })
    },
  },
  components: { clientModule, skydropdownSelect },
  watch: {
    timeType: {
      handler(val) {
        let that = this
        let { initialValue } = this
        switch (val) {
          case 'date':
            initialValue && that.getDetailDay()
            break
          case 'week':
            initialValue && that.getWeek()
            break
          case 'month':
            initialValue && that.getDetailMonth()
            break
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.getReportDetail-select {
  // box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
  border-radius: 4px;
  background-color: #fff;
  // margin-bottom: 10px;
  padding: 0 24px;
  .time-title {
    font-size: 16px;
    columns: #333;
    margin: 0 10px 10px 0;
  }
  .time-switch {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .time-select {
      margin: 10px 0;
    }
    .time-picker {
      margin: 10px 0;
    }
    .time-date {
      color: #666;
      margin: 10px 0;
      margin-left: 20px;
      font-size: 16px;
    }
    .el-date-editor {
      margin-left: 52px;
      .el-range-separator {
        padding: 0;
      }
    }
    .el-dropdown {
      color: #5aa0ff;
    }
  }
}
</style>
